import React from "react";
import { Trash2, Plus } from "lucide-react";
import TravelFormInput from "src/components/travel/form/TravelFormInput";
import TravelFormSelect from "src/components/travel/form/TravelFormSelect";
import { EMPTY_PAYMENT, CARD_TYPE_OPTIONS } from "src/helpers/travelHelper";

const TravelPayments = ({ formData, setFormData }) => {
  const payments = formData.payments || [];

  const handlePaymentChange = (index, field, value) => {
    const updatedPayments = [...payments];
    updatedPayments[index] = { ...updatedPayments[index], [field]: value };
    setFormData({ ...formData, payments: updatedPayments });
  };

  const addPayment = () => {
    setFormData({ ...formData, payments: [...payments, EMPTY_PAYMENT] });
  };

  const removePayment = (index) => {
    const updatedPayments = payments.filter((_, i) => i !== index);
    setFormData({ ...formData, payments: updatedPayments });
  };

  return (
    <div className="col-span-12 space-y-6">
      <h4 className="mb-4 border-b border-gray-100 pb-2 text-lg font-bold text-[#2D0B31]">Credit Cards</h4>

      {payments.map((item, index) => (
        <div
          key={index}
          className="group relative mb-6 rounded-xl border border-gray-200 bg-gray-50/50 p-5 transition-all hover:border-[#2D0B31]/30">
          <button
            type="button"
            onClick={() => removePayment(index)}
            className="absolute right-4 top-4 text-gray-400 transition-colors hover:text-red-500">
            <Trash2 size={18} />
          </button>

          <div className="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2">
            <TravelFormSelect
              label="Card Type"
              options={CARD_TYPE_OPTIONS}
              value={item.type}
              onChange={(e) => handlePaymentChange(index, "type", e.target.value)}
              required
            />
            <TravelFormInput
              label="Credit Card No."
              value={item.number}
              onChange={(e) => handlePaymentChange(index, "number", e.target.value)}
              required
            />
            <TravelFormInput
              label="Expiration"
              placeholder="MM/YY"
              value={item.expiration}
              onChange={(e) => handlePaymentChange(index, "expiration", e.target.value)}
              required
            />
            <TravelFormInput
              label="Name on Card"
              value={item.nameOnCard}
              onChange={(e) => handlePaymentChange(index, "nameOnCard", e.target.value)}
            />
            <TravelFormInput
              label="Remark"
              className="md:col-span-2"
              value={item.remark}
              onChange={(e) => handlePaymentChange(index, "remark", e.target.value)}
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={addPayment}
        className="flex items-center gap-2 rounded-lg bg-[#2D0B31]/5 px-4 py-2 text-sm font-bold text-[#2D0B31] transition-colors hover:text-[#4a1352]">
        <Plus size={16} /> Add new payment method
      </button>
    </div>
  );
};

export default TravelPayments;
